import React, { useState, useCallback, ReactNode } from "react";
import classnames from "classnames";
import { makeStyles, createStyles } from "@material-ui/core";
import { Text } from "../Ui/Text";
import { SeatInfo } from "./SeatInfoV1";
import { IVenueInfo } from "../../interface/IShareInfo";

const useStyles = makeStyles(({ palette, breakpoints }) => {
  return createStyles({
    root: {
      background: "#fff",
      padding: 20,
      border: "1px solid #ebebeb",
      borderRadius: 2,
      marginBottom: 10,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      [breakpoints.down("sm")]: {
        padding: 10
      }
    },
    venueName: {
      fontWeight: 400,
      marginBottom: 4
    },

    eventName: {
      marginBottom: 4,
      textAlign: "center",
      [breakpoints.down("sm")]: {
        padding: 15
      }
    },
    descriptionText: {
      textAlign: "center",
      fontWeight: 400
    },

    whenText: {
      // textTransform: "uppercase",
      marginTop: 20,
      marginBottom: 20
    },
    divider: {
      width: "100%",
      height: 1,
      backgroundColor: "#ebebeb",
      textTransform: "uppercase"
    }
  });
});

interface IProps {
  venueInfo: IVenueInfo | undefined;
  loading: boolean;
  children: ReactNode;
}

export const TicketInfoPanelV1 = ({
  venueInfo = {
    eventName: "",
    eventDescription: "",
    venueName: "",
    state: "",
    when: "",
    productId: ""
  },
  loading,
  children
}: IProps) => {
  const classes = useStyles({});

  return (
    <div className={classes.root}>
      <Text variant="h4" className={classes.venueName}>
        {venueInfo.venueName}
      </Text>
      <Text variant="h2" className={classes.eventName}>
        {venueInfo.eventName}
      </Text>
      <Text variant="h4" className={classes.descriptionText}>
        {/*description is wrong field for subtitle  {venueInfo.eventDescription} */}
      </Text>
      <Text variant="h4" className={classes.whenText}>
        {venueInfo.when}
        {/* {venueInfo ? venueInfo.when : ""} */}
      </Text>
      <input type="hidden" name="productId" value={venueInfo.productId} />
      <div className={classes.divider} />
      {children}
    </div>
  );
};
